<template>
  <v-col
    :cols="cols"
    :sm="sm"
    :md="md"
    :lg="lg">
    <v-text-field
      v-model="texto"
      v-bind="$attrs"
      filled
      :rounded="!hasError"
      :outlined="hasError"
      height="60"
      hide-details
      class="my-input-second custom-label-color-orange"
      color="#FEC240"
      background-color="naranja2"
      v-on="$listeners"
      @update:error="errorChange"
      @blur="validateError"
      @keypress="soloNumeros($event)">
      <template v-slot:label>
        <strong :class="hasError ? '' : 'custom-input-label-color-orange'">
          {{ $attrs.label }}
        </strong>
      </template>
      <template v-if="$attrs['prepend-icon']" v-slot:prepend>
        <v-icon
          v-if="$listeners['click:prepend']"
          :class="iconColor"
          @click="$emit('click:prepend')">
          {{ $attrs['prepend-icon'] }}
        </v-icon>
        <v-icon
          v-else
          :class="iconColor">
          {{ $attrs['prepend-icon'] }}
        </v-icon>
      </template>
      <template v-if="$attrs['append-icon']" v-slot:append>
        <v-icon
          v-if="$listeners['click:append']"
          :class="iconColor"
          @click="$emit('click:append')">
          {{ $attrs['append-icon'] }}
        </v-icon>
        <v-icon
          v-else
          :class="iconColor">
          {{ $attrs['append-icon'] }}
        </v-icon>
      </template>
      <template v-if="$attrs['prepend-inner-icon']" v-slot:prepend-inner>
        <v-icon
          v-if="$listeners['click:prepend-inner']"
          :class="iconColor"
          @click="$emit('click:prepend-inner')">
          {{ $attrs['prepend-inner-icon'] }}
        </v-icon>
        <v-icon
          v-else
          :class="iconColor">
          {{ $attrs['prepend-inner-icon'] }}
        </v-icon>
      </template>
    </v-text-field>
  </v-col>
</template>

<script>
export default {
  name: 'CustomTextFieldOrange',
  inheritAttrs: false,
  props: {
    value: {
      default() {
        return this.value || null;
      },
    },
    cols: {
      type: String,
      default: '12',
    },
    sm: {
      type: String,
      default() {
        return this.sm || this.cols;
      },
    },
    md: {
      type: String,
      default() {
        return this.md || this.sm;
      },
    },
    lg: {
      type: String,
      default() {
        return this.lg || this.md;
      },
    },
  },
  data() {
    return {
      hasError: false,
      greyIcon: 'naranja3--text',
      redIcon: 'error--text',
    };
  },
  methods: {
    soloNumeros(evt) {
      if (this.$attrs.type === 'number') {
        const charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31
          && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
          evt.preventDefault();
        }
      }
    },
    validateError({ srcElement }) {
      let clases = '';
      srcElement.labels.forEach((element) => {
        clases += element.className;
      });
      this.hasError = clases.toLowerCase().indexOf('error') !== -1;
    },
    errorChange(event) {
      this.hasError = event;
    },
  },
  computed: {
    iconColor() {
      return this.hasError ? this.redIcon : this.greyIcon;
    },
    texto: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.$attrs.type === 'number') {
          this.$emit('input', Number(val));
          return;
        }
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" >
.my-input-second.v-input .v-input__slot {
  border-radius: 10px;
}
.custom-label-color-orange .v-label {
  color: #FEC240;
  opacity: 1;
}
.custom-label-color-orange .v-text-field__prefix {
  color: #FEC240;
  font-weight: 500 !important;
}
.custom-label-color-orange .v-text-field__suffix {
  color: #FEC240;
  font-weight: 500 !important;
}
.custom-label-color-orange input{
  color: #FEC240 !important;
  font-weight: 500 !important;
}
.custom-input-label-color-orange {
  color: #FEC240 !important;
}
.v-label .v-label--active .theme--light {
  color: #FEC240 !important;
}
.greyIcon.v-input__append-inner i {
  color: #FEC240 !important;
}
// .v-text-field__slot input {
//   color: #1B1BAF !important;
// }
// .v-text-field--outlined fieldset {
//   border-color: #F2F6FF !important;
// }
// .v-text-field--outlined fieldset :focus {
//   border-color: #1642a8 !important;
// }
</style>
